import React from 'react';
import Icon from './AppIcon';
import Button from './ui/Button';

function CircleProgress({ percent, size = 140, stroke = 12, color = "#22c55e", bg = "#222" }) {
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  return (
    <svg width={size} height={size} className="block mx-auto">
      <circle
        cx={size / 2}
        cy={size / 2}
        r={r}
        fill="none"
        stroke={bg}
        strokeWidth={stroke}
      />
      <circle
        cx={size / 2}
        cy={size / 2}
        r={r}
        fill="none"
        stroke={color}
        strokeWidth={stroke}
        strokeDasharray={c}
        strokeDashoffset={c - (percent / 100) * c}
        strokeLinecap="round"
        style={{ transition: "stroke-dashoffset 0.5s" }}
      />
      <text
        x="50%"
        y="50%"
        textAnchor="middle"
        dy="0.35em"
        fontSize={size * 0.22}
        fill="#fff"
        fontWeight="bold"
      >
        {Math.round(percent)}%
      </text>
    </svg>
  );
}

const ShowProgressModal = ({ show, progress, onClose, sourcePlatform }) => {
  console.log('sourcePlatform', sourcePlatform)
  if (!show) return null;
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-60 z-50">
      <div className="bg-[#0f172b] rounded-2xl shadow-2xl p-10 w-full max-w-2xl flex flex-col items-center mx-[20px]">
        <div className={`flex items-center justify-center mb-6 gap-4 ${sourcePlatform==="spotify" ? "flex-row-reverse" : ""}`}>
          <Icon name="Play" size={40} className="text-error" />
          <span className="mx-2 text-3xl">→</span>
          <Icon name="Music" size={40} className="text-success" />
        </div>
        <div className="flex flex-col items-center w-full">
          <div className="relative flex flex-col items-center justify-center mb-4">
            <CircleProgress
              percent={progress.total ? (progress.current / progress.total) * 100 : 0}
              size={140}
              stroke={12}
              color="#22c55e"
              bg="#222"
            />
           
          </div>
          <div className="flex justify-between w-full text-xs mt-1 mb-2 px-2">
            <span className="text-white">{progress.current}/{progress.total} tracks</span>
          </div>
          <div className="mb-3 text-center w-full">
            <strong className="text-white">Current:</strong> <span className="text-white">{progress.currentTrack?.title || "—"}</span>
          </div>
          <div className="flex justify-between text-xs mb-2 w-full px-2">
            <span className="text-success">Success: {progress.success}</span>
            <span className="text-error">Failed: {progress.failed}</span>
          </div>
          {progress.status === "done" && (
            <div className="text-center mt-4">
              <div className="text-lg text-success font-bold mb-2 animate-pulse">All playlists transferred successfully!</div>
              <Button onClick={onClose} className="mt-2">Close</Button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ShowProgressModal;